import { IChoiceGroupStyles } from "@fluentui/react";
import { ChoiceGroupProps } from "./ChoiceGroup";

/** The styling for the entire choice group, used only for select buttons */
export const getContainerStyles = (optionType: ChoiceGroupProps["optionType"]): IChoiceGroupStyles => {
    return ["selectButton", "mediaButton"].includes(optionType) ? {
        root: {
            width: "100%"
        },
        flexContainer: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between"
        }
    } : {};
};
